<template>
    <Layout>
        <div class="col-lg-12">
            <div class="card" style="min-height: 100vh">
                <CustomDomain />
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import CustomDomain from '@/views/pages/phase2/manager-form/email/components/custom-domain/main.vue';

export default {
    name: 'MasterCustomDomain',
    page: {
        title: '独自ドメイン',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        CustomDomain
    }
};
</script>

<style lang="scss" scoped></style>
